import { ExternalLinkIcon } from '@radix-ui/react-icons'
import { Tooltip } from 'antd'
import { ExternalLink } from 'components/ExternalLink'
import React, { ReactNode } from 'react'
import styled from 'styled-components'

const StyledLinkContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 8px;
  background-color: ${({ theme }) => theme.forecast.background3};
  color: ${({ theme }) => theme.forecast.text1};
  border-radius: 0.25rem;
  position: relative;
  font-size: 10px;
  cursor: pointer;
`

const SalesforceCardContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 0.5rem;
`

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
`

const LinkContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
`

const NameText = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
`

const DateText = styled.div`
  font-size: 0.75rem;
`

interface SalesforceCardProps {
  label: ReactNode
  id: string
  startDate?: string
  endDate?: string
}

export const SalesforceCard = ({
  label,
  id,
  startDate,
  endDate,
}: SalesforceCardProps) => {
  const handleLinkClick = (e: React.MouseEvent) => {
    e.stopPropagation()
  }

  return (
    <SalesforceCardContainer>
      <TextContainer>
        <NameText>{label}</NameText>
        {(startDate || endDate) && (
          <DateText>
            Scheduled for: {startDate} {endDate ? `to ${endDate}` : ''}
          </DateText>
        )}
      </TextContainer>
      <LinkContainer onClick={handleLinkClick}>
        <ExternalLink
          href={`https://geckorobotics.lightning.force.com/lightning/r/Account/${id}/view`}
          target='_blank'>
          <Tooltip title='Open in Salesforce'>
            <StyledLinkContainer>
              <ExternalLinkIcon />
            </StyledLinkContainer>
          </Tooltip>
        </ExternalLink>
      </LinkContainer>
    </SalesforceCardContainer>
  )
}
